import ImagePlaceholder from '../components/ImagePlaceholder';
import Footer from '../components/Footer';
import { Heart, Sparkles, Award } from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen pt-20" data-testid="about-page">
      {/* Hero Section */}
      <section 
        className="py-20 px-6 lg:px-12 relative"
        style={{
          backgroundImage: 'url(https://static.prod-images.emergentagent.com/jobs/bfce07a1-7139-48cf-8f8e-534e5eeee823/images/968e2fa01c7ec45f042535e69fd33cd7eede66b0817a712b28f3b717971ec588.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
        data-testid="about-hero"
      >
        <div className="absolute inset-0 bg-white/75 backdrop-blur-sm"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl mb-6">Our Story</h1>
          <p className="text-xl text-[var(--text-main)] leading-relaxed">
            Where passion meets pastry in every handcrafted creation
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-16 lg:py-24 px-6 lg:px-12" data-testid="story-section">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <ImagePlaceholder aspect="portrait" />
              <p className="text-center text-sm text-[var(--text-muted)] mt-4">Owner photo placeholder</p>
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl sm:text-4xl mb-6">Handcrafted with Love</h2>
              <p className="text-[var(--text-main)] text-lg leading-relaxed">
                Pearl Pastries was born from a passion for creating beautiful, delicious desserts 
                that make every occasion special. Each treat is handmade with premium ingredients 
                and careful attention to detail.
              </p>
              <p className="text-[var(--text-main)] text-lg leading-relaxed">
                We believe that desserts should be as beautiful as they are delicious. Whether it's 
                a birthday celebration, wedding, or just because, we pour our hearts into every 
                creation to ensure it's perfect for your special moment.
              </p>
              <p className="text-[var(--text-main)] text-lg leading-relaxed">
                Our boutique approach means every order receives personalized attention. We work 
                closely with you to bring your dessert vision to life, customizing colors, flavors, 
                and designs to match your unique style.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 lg:py-24 px-6 lg:px-12 bg-[var(--background-secondary)]" data-testid="values-section">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl sm:text-4xl text-center mb-12">What Makes Us Special</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-3xl border border-[var(--border-soft)] card-hover" data-testid="value-handmade">
              <div className="w-16 h-16 mx-auto mb-6 bg-[var(--primary)]/20 rounded-full flex items-center justify-center">
                <Heart className="text-[var(--accent-gold)]" size={32} />
              </div>
              <h3 className="text-2xl mb-4">Handmade</h3>
              <p className="text-[var(--text-muted)] leading-relaxed">
                Every dessert is crafted from scratch with love and care. No mass production, 
                just genuine artisanal baking.
              </p>
            </div>
            
            <div className="text-center p-8 bg-white rounded-3xl border border-[var(--border-soft)] card-hover" data-testid="value-custom">
              <div className="w-16 h-16 mx-auto mb-6 bg-[var(--primary)]/20 rounded-full flex items-center justify-center">
                <Sparkles className="text-[var(--accent-gold)]" size={32} />
              </div>
              <h3 className="text-2xl mb-4">Custom Designs</h3>
              <p className="text-[var(--text-muted)] leading-relaxed">
                Your vision, our expertise. We specialize in bringing your dream desserts to 
                life with personalized designs and themes.
              </p>
            </div>
            
            <div className="text-center p-8 bg-white rounded-3xl border border-[var(--border-soft)] card-hover" data-testid="value-quality">
              <div className="w-16 h-16 mx-auto mb-6 bg-[var(--primary)]/20 rounded-full flex items-center justify-center">
                <Award className="text-[var(--accent-gold)]" size={32} />
              </div>
              <h3 className="text-2xl mb-4">Premium Quality</h3>
              <p className="text-[var(--text-muted)] leading-relaxed">
                We use only the finest ingredients to ensure every bite is as delicious as 
                it is beautiful.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 lg:py-24 px-6 lg:px-12" data-testid="about-cta">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl mb-6">Ready to Order?</h2>
          <p className="text-[var(--text-muted)] text-lg mb-8 leading-relaxed">
            Let's create something beautiful together. Place your custom order today!
          </p>
          <a 
            href="/ordering"
            className="inline-block px-12 py-4 bg-[var(--accent-gold)] text-white rounded-full text-lg font-medium button-hover"
            data-testid="about-order-button"
          >
            Start Your Order
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}